type DatadogRumApi = NonNullable<Window['DD_RUM']>

/**
 * Run a callback once the Datadog RUM SDK is ready, passing the live SDK
 * instance.
 *
 * The CDN loader installs a lightweight stub on `window.DD_RUM` that only
 * queues `onReady` callbacks, then replaces the global with the fully-featured
 * SDK once the async bundle finishes loading. Callbacks must therefore read the
 * SDK from `window.DD_RUM` at execution time: a reference captured before the
 * bundle loads still points at the stub, whose telemetry methods (`addAction`,
 * `setUser`, `addError`, `addFeatureFlagEvaluation`, …) do not exist and throw
 * `TypeError` when invoked.
 */
export function onDatadogRumReady(callback: (datadogRum: DatadogRumApi) => void): void {
    if (typeof window === 'undefined' || !window.DD_RUM) {
        return
    }
    window.DD_RUM.onReady(() => {
        if (window.DD_RUM) {
            callback(window.DD_RUM)
        }
    })
}
